<template>
  <div class="sure">
    <div class="sure_top d_f ali_c j_c">
      <div
        class="t_a"
        :class="type == '1' ? 'long' : ''"
      >
        <img
          src="../assets/img/sure_icon.png"
          alt=""
        >
        <div class="s_suc">
          提交成功
        </div>
        <!-- <div
          v-if="type == '1'"
          class="s_sub"
        >
          我们将第一时间受理您的投诉信息，<br>
          并在三个工作日内回复你，请保持您的手机畅
        </div>
        <div
          v-else
          class="s_sub"
        >
          你的咨询内容我们已经收到啦~ <br>我们将在三个工作日内回复你，请在 <br><span>个人中心</span>—<span>咨询记录</span>里查看
        </div> -->
      </div>
    </div>
    <div class="sure_bot">
      <div class="d_f ali_c j_c">
        <van-count-down
          :time="time"
          format="ss 秒"
          @finish="$router.push('/destination')"
        /> 后自动跳转到首页
      </div>
      <div
        class="cur_p"
        @click="$router.push('/destination')"
      >
        点击返回首页
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SureInput",
    props:{
      type:{//标题
        type:String,
        default:''
      },
    },
    data() {
      return {
        time:5000,
      }
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .sure{
    .sure_bot{
      ::v-deep .van-count-down,
      .d_f{
        font-size: 26px;
        font-weight: bold;
        color: #A0A0A0;
      }
      .d_f{
        margin-bottom: 44px;
      }
      .cur_p{
        font-size: 30px;
        font-weight: bold;
        color: #4C90F1;
      }
      height: 200px;
      text-align: center;
    }
    .sure_top{
      >.t_a{
        &.long{
          width: 565px;
        }
        .s_sub{
          >span{
            color: #2985F4;
          }
          font-size: 24px;
          font-weight: bold;
          color: #8E8E8E;

        }
        .s_suc{
          font-size: 34px;
          font-weight: bold;
          color: #4C90F1;
          margin-bottom: 40px;
        }
        img{
          height: 158px;
          width: 176px;
          margin-bottom: 35px;
        }
        width: 398px;
      }
      height: calc(100% - 200px);
    }
    /*height: calc(100% - 85px);*/
    height: calc(100%);
    background-color: white;
  }

</style>
